import { c as _c } from "react/compiler-runtime";
import { NO_TRANSLATE_CLASS, Text } from "@flat-ui";
/** Standard look of a value in the info bar: bold, dark and on a single line. */
export function InfoBarValue(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      fontSize: "1.125rem",
      fontWeight: "bold",
      color: "primary.main"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Text variant="bodyM" shouldElide={true} className={NO_TRANSLATE_CLASS} sx={t1}>{children}</Text>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}